import * as THREE from 'three';
import { GLTFLoader } from 'three/addons/loaders/GLTFLoader.js';

// Setup basic Three.js scene
const scene = new THREE.Scene();
const section = document.querySelector('.main-content .custom-section');
const camera = new THREE.PerspectiveCamera( 75, section.offsetWidth/ section.offsetHeight, 0.1, 1000 );
// make the camera look down
camera.position.set(0, 4, 0);
camera.up.set(0, 0, -1);
camera.lookAt(0, 0, 0);
const renderer = new THREE.WebGLRenderer({alpha:true});
renderer.setSize( section.offsetWidth, section.offsetHeight );
const canvas = renderer.domElement;
canvas.style.zIndex = "8";
canvas.style.position = 'absolute';
canvas.style.left = '0';
canvas.style.top = '0';
document.querySelector('.main-content').appendChild( canvas );

// Set up the directional light coming from the camera's position
const cameraLight = new THREE.DirectionalLight(0xffffff, 2);
cameraLight.position.set(camera.position.x, camera.position.y, camera.position.z);
cameraLight.target.position.set(0, 0, 0);
scene.add(cameraLight);

const audioListener = new THREE.AudioListener();
camera.add( audioListener );

const ambientMusic = new THREE.Audio( audioListener );
scene.add( ambientMusic );

const musicLoader = new THREE.AudioLoader();
const playPauseElement = document.querySelector('#play');
const playPauseDisplay = document.querySelector('.play-text');
const volumeSLiderElement = document.querySelector('#volume');

musicLoader.load(
  // resource URL
  musicUrl,
  
  // onLoad callback
  function ( audioBuffer ) {
    ambientMusic.setBuffer( audioBuffer );
    playPauseElement.onchange = function (e) {
      if (e.target.checked) {
        playPauseDisplay.innerHTML = "pause"
        ambientMusic.play();
      }
      else {
        playPauseDisplay.innerHTML = "play"
        ambientMusic.pause();
      }
    }
    volumeSLiderElement.oninput = function(e) {
      ambientMusic.setVolume(e.target.value / 100);
    }
  },
  
  // onProgress callback
  function ( xhr ) {
    console.log( (xhr.loaded / xhr.total * 100) + '% loaded' );
  },
  
  // onError callback
  function ( err ) {
    console.log( err );
  }
);

// Load the GLB file
const modelLoader = new GLTFLoader();
const modelUrl = 'https://cdn.shopify.com/3d/models/e52bd4532a22d5ab/whale-shark-1.glb';
let mixer; // mixer for animations
let model;

modelLoader.load( modelUrl , function ( gltf ) {
  // Add the model to the scene
  model = gltf.scene;
  scene.add( model );
  model.scale.set(0.23,0.23,0.23);  // Adjust size if needed
  
  // Add animation mixer  
  mixer = new THREE.AnimationMixer(model);
  gltf.animations.forEach((clip) => {
    mixer.clipAction(clip).play();
  });
});

//Create scale function to scale vertical alignment to positioning on 3d plane
const scale = (fromRange, toRange) => {
        const d = (toRange[1] - toRange[0]) / (fromRange[1] - fromRange[0]);
        return from =>  (from - fromRange[0]) * d + toRange[0];
    };
let sectionHeight = section.offsetHeight;
let screenHeight = window.innerHeight;
let scrollRange = [0,sectionHeight-screenHeight];
let swimRange = [-2.5,2]

// Resize Event Listener
window.addEventListener('resize', (e) => {
  camera.aspect = section.offsetWidth/ section.offsetHeight;
  camera.updateProjectionMatrix();
  
  renderer.setSize( section.offsetWidth, section.offsetHeight );
  
  sectionHeight = section.offsetHeight;
  screenHeight = window.innerHeight;
  scrollRange = [0,sectionHeight-screenHeight];
});

// Scroll Event Listener
let scrollPos = scale(scrollRange,swimRange)(window.scrollY);

window.addEventListener('scroll', () => {
  scrollPos = scale(scrollRange,swimRange)(window.scrollY)
});

const leftCheckpoints = document.querySelectorAll('.bubble-container-left');
const rightCheckpoints = document.querySelectorAll('.bubble-container-right');
const bubble = document.querySelector('.bubble ')

function isAtCheckpoint(checkpointArray) {
  const checkingOffset = bubble.offsetHeight;
  const pagePos = scale(swimRange,[screenHeight * 0.4,sectionHeight - screenHeight * 0.2])(scrollPos);
  
  for (let i = 0; i < checkpointArray.length; i++) {
    if (pagePos > checkpointArray[i].offsetTop && pagePos < checkpointArray[i].offsetTop + checkingOffset) return true;
  }

  return false;
}

function moveTo(model, newPos) {
  newPos = newPos || new THREE.Vector3(model.position.x,model.position.y,model.position.z);

  if (isAtCheckpoint(leftCheckpoints, newPos.z)) newPos.x = 0.1;
  else if (isAtCheckpoint(rightCheckpoints, newPos.z)) newPos.x = -0.1;
  else newPos.x = 0;

  const mock = new THREE.Object3D();

  model.parent.add(mock);
  mock.position.copy(model.position);
  mock.lookAt(newPos);

  let targetQuaternion = mock.quaternion.clone();

  mock.parent.remove(mock);
  model.quaternion.slerp(targetQuaternion, 0.03)
  model.position.lerp(newPos,0.03);
}

function animate() {

    if (mixer) {
        mixer.update(0.05); // Adjust speed here if necessary
    }

    if (model && scroll) {
      moveTo(model,new THREE.Vector3(model.position.x,model.position.y,scrollPos))
    }
	renderer.render( scene, camera );
}

renderer.setAnimationLoop( animate );

// create random int function
function getRandomInt(range = [0,100]) {
    const min = Math.ceil(range[0]);
    const max = Math.floor(range[1]);
    return Math.floor(Math.random() * (max - min + 1)) + min;
}

// function to add elements to the background randomly inside container
function addBackgroundElement(imageUrls, container, options = []) {
  options = Object.assign({}, {
    widthRange: [50,100],
    imageRatio: 1,
    topOffset: 0,
    classList: [],
    xRange: [0,100],
    yRange: [0,100]
  }, options);
  const element = document.createElement('img');
  
  const imageRatio = options.imageRatio;
  const width = getRandomInt(options.widthRange);
  const height = width * imageRatio;
  const topOffset = options.topOffset;
  
  
  element.width = width.toString();
  element.height = height.toString();
  element.src = imageUrls[getRandomInt([0, imageUrls.length - 1])];
  element.style.left = 'calc(' + getRandomInt(options.xRange) + '% - ' + width + 'px)';
  element.style.top = 'calc(' + getRandomInt(options.yRange) + '% - ' + height + 'px)';
  element.classList.add('bg-elements');
  for (let i = 0; i < options.classList.length; i++) {
    element.classList.add(options.classList[i]);
  }
  if (options.auxContainer) options.auxContainer.appendChild(element)
  else container.appendChild(element)
  return element;
}

const bgFishOptions = {
  widthRange: [200,500],
  topOffset: 300,
  imageRatio: 1280/957
}
let bgFishArray = [];
for (let i = 0; i < 7; i++) {
  bgFishArray.push(addBackgroundElement(["//afishnamedfred.com/cdn/shop/t/3/assets/fnf-bg-fishes1.png?v=140556054353469143711738141392", "//afishnamedfred.com/cdn/shop/t/3/assets/fnf-bg-fishes2.png?v=140911143669371432711738141407"],section,bgFishOptions))
}

const bgBubbleOptions = {
  classList: ['float'],
  auxContainer: document.querySelector('.small-bubbles-container')
}
let ambientBubbleArray = [];
for (let i = 0; i < 14; i++) {
  ambientBubbleArray.push(addBackgroundElement(["//afishnamedfred.com/cdn/shop/t/3/assets/fnf-ambient-bubble.png?v=18563229450289053741737634101"],document.querySelector('.bubbles-container'), bgBubbleOptions))
}

document.querySelectorAll('.bubble-container').forEach((element) => {
  element.addEventListener('click',e => {
    let bubble = e.currentTarget;
    if (!bubble.classList.contains('animate')) {
      bubble.classList.add('animate')
      setTimeout( () => {
          bubble.classList.remove('animate')
      }, 1200)
    }
  })
})

document.body.addEventListener('click', e => {
  if (e.target.classList.contains('popup-open')) {
    let popup = document.querySelector('.popup-container:not(.hidden)')
    console.log(popup)
    if (popup) {
      let target = popup.classList.value.split(' ').find(cls => cls.toLowerCase().includes('section-name-')).replace('section-name-','')
    console.log(target)
      if (target) {
        openPopup(target, false)
      }
    }
  }
})